module.exports = __webpack_public_path__ + "public/images/generated-arts-crafts.83423fe57ec20d0b97b695724da3239a.jpg";